function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#7098F2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 26.4,
  stroke: "white",
  strokeWidth: 1.2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.4227 26.58C28.8098 26.6398 29.2009 26.6698 29.5926 26.67C31.4871 26.6637 33.3058 25.9247 34.6677 24.6076C36.0295 23.2905 36.8288 21.4977 36.8984 19.6044C36.968 17.7112 36.3024 15.8644 35.0409 14.4509C33.7794 13.0375 32.0199 12.1669 30.1309 12.0216C28.242 11.8763 26.3701 12.4675 24.9073 13.6714C23.4445 14.8753 22.5042 16.5985 22.2834 18.4802C22.0626 20.3618 22.5784 22.2558 23.7228 23.7657C24.8672 25.2755 26.5514 26.284 28.4227 26.58ZM25.6476 15.39C26.5201 14.4942 27.6689 13.9184 28.9087 13.7554C30.1485 13.5925 31.4071 13.8518 32.4815 14.4916C33.5558 15.1315 34.3835 16.1145 34.8308 17.2822C35.2781 18.4499 35.3191 19.7343 34.9472 20.9282C34.5752 22.122 33.8121 23.1559 32.7808 23.863C31.7494 24.57 30.5099 24.9091 29.2622 24.8255C28.0145 24.742 26.8314 24.2407 25.9035 23.4024C24.9756 22.5641 24.357 21.4378 24.1476 20.205C23.9971 19.3409 24.0547 18.4535 24.3156 17.6162C24.5765 16.7788 25.033 16.0157 25.6476 15.39Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.1476 40.1249C14.9831 40.7069 14.9557 41.3192 15.0675 41.9136C15.1793 42.508 15.4273 43.0685 15.792 43.5509C16.1568 44.0334 16.6284 44.4248 17.1698 44.6944C17.7112 44.9641 18.3078 45.1046 18.9126 45.1049H40.2577C40.8632 45.1022 41.4597 44.9595 42.001 44.6882C42.5423 44.4168 43.0136 44.024 43.3781 43.5405C43.7425 43.0569 43.9903 42.4958 44.1021 41.9007C44.2139 41.3056 44.1867 40.6927 44.0226 40.1099C43.1358 36.9636 41.2456 34.1932 38.6395 32.2201C36.0333 30.2469 32.8539 29.1791 29.5851 29.1791C26.3163 29.1791 23.137 30.2469 20.5308 32.2201C17.9247 34.1932 16.0344 36.9636 15.1476 40.1099V40.1249ZM29.5776 30.9899C32.4486 31.001 35.2387 31.9426 37.5294 33.6734C39.8201 35.4043 41.4879 37.8311 42.2826 40.5899C42.3759 40.9052 42.3944 41.2379 42.3367 41.5615C42.2789 41.8852 42.1465 42.1909 41.9499 42.4544C41.7534 42.718 41.4981 42.932 41.2043 43.0797C40.9106 43.2273 40.5864 43.3044 40.2577 43.3049H18.9126C18.5864 43.3061 18.2645 43.2307 17.9727 43.0848C17.681 42.9389 17.4274 42.7266 17.2326 42.4649C17.0332 42.2037 16.8969 41.8998 16.8345 41.5772C16.772 41.2545 16.7851 40.9217 16.8726 40.6049C17.669 37.8372 19.343 35.403 21.6425 33.6689C23.942 31.9348 26.7426 30.9946 29.6226 30.9899H29.5776Z",
  fill: "white"
});

var SvgStatusCandidate = function SvgStatusCandidate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStatusCandidate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status-candidate.ba931a33.svg";
export { ForwardRef as ReactComponent };